
<template>
  <div class="phone-verify-content">
    <div class="phone-verify-container">
      <div class="phone-input-title">输入手机号</div>
      <van-field
        class="phone-field"
        placeholder='请输入手机号'
        size="large"
        maxlength="13"
        input-align="left"
        clearable
        @click-left-icon="selectRegionCode"
        v-model="phone"
        type="number"
        :error-message="inputPhoneErrorMsg"
      >
        <div slot="left-icon" class="region-container" @click="selectRegionCode">
          <div>{{ currentRegion }}</div>
          <i class="iconfont icon-arrow-down1" />
        </div>
      </van-field>
      <van-field
        class="code-field"
        v-model="smscode"
        placeholder='请输入验证码'
        size="large"
        maxlength="6"
        input-align="left"
        clearable
        type="number"
        :error-message="inputCodeErrorMsg"
      >
        <div class="code-button" slot="button" @click="sendCodeAction" >{{sendCodeButtonPrompt}}</div>
      </van-field>
      <div class="action-button" @click="submitAction">提交</div>
    </div>
    <van-popup
      class="select-region-view"
      v-model="showRegionSelectView"
      position="bottom"
    >
      <van-picker
        v-if="showRegionSelectView"
        show-toolbar
        title="国际电话区号"
        :columns="regionColumns"
        :default-index="38"
        @cancel="onRegionCancel"
        @confirm="onRegionConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import ajax from '../../utils/ajax'
// import { alert } from '../../utils/common'

const maxCount = 60
const regionList = ['+1', '+7', '+20', '+27', '+30', '+31', '+32', '+33', '+34', '+36', '+39', '+40', '+41', '+43', '+44', '+45', '+46', '+47', '+48', '+49', '+51', '+52', '+53', '+54', '+55', '+56', '+57', '+58', '+60', '+61', '+62', '+63', '+64', '+65', '+66', '+81', '+82', '+84', '+86', '+90', '+91', '+92', '+93', '+94', '+95', '+98', '+211', '+212', '+213', '+216', '+218', '+220', '+221', '+222', '+223', '+224', '+225', '+226', '+227', '+228', '+229', '+230', '+231', '+232', '+233', '+234', '+235', '+236', '+237', '+238', '+239', '+240', '+241', '+242', '+243', '+244', '+245', '+248', '+249', '+250', '+251', '+252', '+253', '+254', '+255', '+256', '+257', '+258', '+260', '+261', '+262', '+263', '+264', '+265', '+266', '+267', '+268', '+269', '+297', '+298', '+299', '+350', '+351', '+352', '+353', '+354', '+355', '+356', '+357', '+358', '+359', '+370', '+371', '+372', '+373', '+374', '+375', '+376', '+377', '+378', '+380', '+381', '+382', '+385', '+386', '+387', '+389', '+420', '+421', '+423', '+501', '+502', '+503', '+504', '+505', '+506', '+507', '+508', '+509', '+590', '+591', '+592', '+593', '+594', '+595', '+596', '+597', '+598', '+599', '+670', '+673', '+675', '+676', '+677', '+678', '+679', '+680', '+682', '+685', '+686', '+687', '+689', '+691', '+850', '+852', '+853', '+855', '+856', '+880', '+886', '+960', '+961', '+962', '+963', '+964', '+965', '+966', '+967', '+968', '+970', '+971', '+972', '+973', '+974', '+975', '+976', '+977', '+992', '+993', '+994', '+995', '+996', '+998', '+1242', '+1246', '+1264', '+1268', '+1284', '+1340', '+1345', '+1441', '+1473', '+1649', '+1664', '+1671', '+1758', '+1767', '+1784', '+1787', '+1809', '+1868', '+1869', '+1876']

export default {
  name: 'PhoneVerify',
  props: {
    callback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      phone: '',
      smscode: '',
      showRegionSelectView: false,
      isSendingCode: false,
      sendCodePrompt: '获取验证码',
      timerLeftCount: maxCount,
      timer: null,
      currentRegion: '+86',
      regionColumns: regionList,
      showPhoneError: false,
      showCodeError: false
    }
  },
  computed: {
    sendCodeButtonPrompt () {
      if (this.timerLeftCount === maxCount) {
        return this.sendCodePrompt
      } else {
        return `${this.sendCodePrompt}(${this.timerLeftCount}s)`
      }
    },
    inputPhoneErrorMsg () {
      return this.showPhoneError ? '请输入手机号' : ''
    },
    inputCodeErrorMsg () {
      return this.showCodeError ? '请输入验证码' : ''
    }
  },
  watch: {},
  methods: {
    onPhoneNumberChanged (value) {
      console.log(value)
    },
    selectRegionCode () {
      this.showRegionSelectView = true
      console.log('选择region')
    },
    sendCodeAction () {
      if (this.phone.length > 0 && this.timerLeftCount === maxCount && !this.isSendingCode) {
        console.log(this.phone)

        this.showPhoneError = false
        this.isSendingCode = true
        if (this.timer) {
          clearInterval(this.timer)
        }
        const phonenumber = `(${this.currentRegion})${this.phone}`
        ajax({
          urlPrefix: '/',
          url: 'captcha/captcha_send',
          data: {
            sms_captcha_type: 'get_coupon',
            message_type: 'txt',
            phone: phonenumber
          },
          loading: '正在发送',
          successMessage: '发送成功',
          accept_all_errors: true
        }).then(result => {
          this.isSendingCode = false
          console.log(result)
          if (result.success) {
            this.timerLeftCount--
            this.timer = setInterval(() => {
              if (this.timerLeftCount === 0) {
                this.timerLeftCount = maxCount
                clearInterval(this.timer)
              } else {
                this.timerLeftCount--
              }
            }, 1000)
          }
        }).catch(err => {
          console.log(err)
          this.isSendingCode = false
        })
      } else if (this.phone.length === 0) {
        this.showPhoneError = true
      }
    },
    submitAction () {
      if (this.phone.length > 0 && this.smscode.length > 0) {
        this.showCodeError = false
        this.showPhoneError = false
        this.$props.callback({
          region: this.currentRegion,
          phone: this.phone,
          smscode: this.smscode
        })
      } else {
        if (this.smscode.length === 0) {
          this.showCodeError = true
        }
        if (this.phone.length === 0) {
          this.showPhoneError = true
        }
      }
    },
    onRegionCancel () {
      this.showRegionSelectView = false
    },
    onRegionConfirm (value, index) {
      console.log(value)
      this.currentRegion = value
      this.showRegionSelectView = false
    }
  }
}
</script>

<style lang="postcss">
/* @import "variables"; */
.phone-verify-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  & .phone-verify-container {
    height: 100%;
    width: 100%;
    max-width: 375px;
    & .phone-input-title {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: bold;
      color: #333333;
      line-height: 33px;
      padding-top: 80px;
      margin-left: 16px;
    }

    & .phone-field {
      font-size: 17px;
      padding-top: 32px;
      &::after {
        left: 16px;
        right: 16px;
        border-bottom: 1px solid #e5e5e5;
      }

      & .van-field__left-icon {
        padding-right: 8px;
        margin-right: 16px;
        border-right: 1px solid #e5e5e5;
      }

      & .region-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        & .icon-arrow-down1 {
          margin-left: 30px;
          font-size: 8px;
          color: #747b93;
        }
      }
    }

    & .code-field {
      font-size: 17px;
      color: #cccccc;
      padding-top: 35px;
      &::after {
        left: 16px;
        right: 16px;
        border-bottom: 1px solid #e5e5e5;
      }

      & .code-button {
        font-family: PingFang SC;
        font-size: 17px;
        color: #666666;
        text-align: right;
        letter-spacing: 0;
        line-height: 24px;
      }
    }

    & .action-button {
      background: #017ffd;
      border-radius: 24px;
      width: calc(100% - 32px);
      height: 48px;
      margin-left: 16px;
      text-align: center;
      font-family: PingFang SC;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 48px;
      margin-top: 30px;
    }
  }

  & .select-region-view  {
    width: 100%;
    height: 40%;
  }
}

</style>
